/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { MetadataRequest } from '../models';
/**
 * PremiumService - axios parameter creator
 * @export
 */
export const PremiumServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Import the Data from Shhet to Table bex_premium
         * @summary Upload a Excell-File
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBexPremium: async (file?: any, metadata?: MetadataRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/premium/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (metadata !== undefined) { 
                localVarFormParams.append('metadata', new Blob([JSON.stringify(metadata)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PremiumService - functional programming interface
 * @export
 */
export const PremiumServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PremiumServiceAxiosParamCreator(configuration)
    return {
        /**
         * Import the Data from Shhet to Table bex_premium
         * @summary Upload a Excell-File
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importBexPremium(file?: any, metadata?: MetadataRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importBexPremium(file, metadata, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PremiumService - factory interface
 * @export
 */
export const PremiumServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PremiumServiceFp(configuration)
    return {
        /**
         * Import the Data from Shhet to Table bex_premium
         * @summary Upload a Excell-File
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBexPremium(file?: any, metadata?: MetadataRequest, options?: any): AxiosPromise<void> {
            return localVarFp.importBexPremium(file, metadata, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PremiumService - interface
 * @export
 * @interface PremiumService
 */
export interface PremiumServiceInterface {
    /**
     * Import the Data from Shhet to Table bex_premium
     * @summary Upload a Excell-File
     * @param {any} [file] image file
     * @param {MetadataRequest} [metadata] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumServiceInterface
     */
    importBexPremium(file?: any, metadata?: MetadataRequest, options?: any): AxiosPromise<void>;

}

/**
 * PremiumService - object-oriented interface
 * @export
 * @class PremiumService
 * @extends {BaseAPI}
 */
export class PremiumService extends BaseAPI implements PremiumServiceInterface {
    /**
     * Import the Data from Shhet to Table bex_premium
     * @summary Upload a Excell-File
     * @param {any} [file] image file
     * @param {MetadataRequest} [metadata] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumService
     */
    public importBexPremium(file?: any, metadata?: MetadataRequest, options?: any) {
        return PremiumServiceFp(this.configuration).importBexPremium(file, metadata, options).then((request) => request(this.axios, this.basePath));
    }
}
